(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["email-popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('email-popup')) return;

    const store = {
      get(area, key) {
        try { return window[area].getItem(key); } catch (e) { return null; }
      },
      set(area, key, value) {
        try { window[area].setItem(key, value); } catch (e) {}
      },
      remove(area, key) {
        try { window[area].removeItem(key); } catch (e) {}
      }
    };

    const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    class EmailPopup extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        if (!this.dialog) return;

        this.form = this.querySelector('[data-popup-form]');
        this.errorEl = this.querySelector('[data-popup-error]');
        this.statusEl = this.querySelector('[data-popup-status]');
        this.submitBtn = this.querySelector('[data-popup-submit]');
        this.designMode = this.hasAttribute('data-design-mode');
        this.delay = Math.max(0, Number(this.dataset.delay || 5)) * 1000;
        this.days = Math.max(0, Number(this.dataset.days || 0));
        this.key = 'email-popup:' + (this.dataset.key || 'default');
        this.onKeydown = (event) => this.handleKeydown(event);

        this.bindEvents();

        if (this.designMode) {
          this.setupEditor();
          return;
        }

        if (this.handleReturnFromNativeSubmit()) return;
        if (this.dataset.enabled === 'false') return;
        if (!this.shouldShow()) return;

        const start = () => {
          this.timer = window.setTimeout(() => this.open(), this.delay);
        };
        if (document.readyState === 'complete') {
          start();
        } else {
          window.addEventListener('load', start, { once: true });
        }
      }

      disconnectedCallback() {
        window.clearTimeout(this.timer);
        if (this.onSectionSelect) {
          document.removeEventListener('shopify:section:select', this.onSectionSelect);
          document.removeEventListener('shopify:section:deselect', this.onSectionDeselect);
          document.removeEventListener('shopify:section:load', this.onSectionLoad);
        }
        document.removeEventListener('keydown', this.onKeydown);
        document.documentElement.classList.remove('email-popup-open');
      }

      handleKeydown(event) {
        if (!this.dialog.open) return;

        if (event.key === 'Escape') {
          event.preventDefault();
          this.close();
          return;
        }

        if (event.key !== 'Tab') return;

        const focusable = [...this.dialog.querySelectorAll(
          'a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), select, textarea:not([disabled])'
        )].filter((el) => el.offsetParent !== null);
        if (!focusable.length) return;

        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        const active = document.activeElement;

        if (event.shiftKey && (active === first || !this.dialog.contains(active))) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && (active === last || !this.dialog.contains(active))) {
          event.preventDefault();
          first.focus();
        }
      }

      bindEvents() {
        this.querySelectorAll('[data-popup-close]').forEach((btn) => {
          btn.addEventListener('click', () => this.close());
        });

        // Keep state tidy however the dialog gets closed
        this.dialog.addEventListener('close', () => {
          this.dialog.classList.remove('is-visible');
          document.documentElement.classList.remove('email-popup-open');
          document.removeEventListener('keydown', this.onKeydown);
        });

        // Click on backdrop (only if the press started on the backdrop too)
        this.dialog.addEventListener('pointerdown', (event) => {
          this.pressedBackdrop = event.target === this.dialog;
        });
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog && this.pressedBackdrop) this.close();
          this.pressedBackdrop = false;
        });

        if (this.form) {
          this.form.addEventListener('submit', () => this.onSubmit());
        }

        const copyBtn = this.querySelector('[data-popup-copy]');
        if (copyBtn) copyBtn.addEventListener('click', () => this.copyCode(copyBtn));
      }

      setupEditor() {
        if (this.dataset.previewSuccess === 'true') this.dataset.state = 'success';

        this.onSectionSelect = (event) => {
          if (event.detail && event.detail.sectionId === this.dataset.sectionId) this.open();
        };
        this.onSectionDeselect = (event) => {
          if (event.detail && event.detail.sectionId === this.dataset.sectionId) this.close();
        };
        document.addEventListener('shopify:section:select', this.onSectionSelect);
        document.addEventListener('shopify:section:deselect', this.onSectionDeselect);

        // Re-open when a settings change re-renders the section
        this.onSectionLoad = (event) => {
          if (event.detail && event.detail.sectionId === this.dataset.sectionId) this.open();
        };
        document.addEventListener('shopify:section:load', this.onSectionLoad);
      }

      shouldShow() {
        if (this.dataset.mobile === 'false' && window.matchMedia('(max-width: 749px)').matches) return false;
        if (store.get('localStorage', this.key + ':subscribed')) return false;

        if (this.days === 0) {
          if (store.get('sessionStorage', this.key + ':closed')) return false;
        } else {
          const closedAt = Number(store.get('localStorage', this.key + ':closed') || 0);
          if (closedAt && Date.now() - closedAt < this.days * 86400000) return false;
        }
        return true;
      }

      open() {
        if (this.dialog.open) return;
        this.lastFocus = document.activeElement;
        // Non-modal on purpose: showModal() would put Shopify's hCaptcha challenge
        // behind the top layer and make it unclickable.
        this.dialog.show();
        document.documentElement.classList.add('email-popup-open');
        document.addEventListener('keydown', this.onKeydown);

        const panel = this.dialog.querySelector('[data-popup-panel]');
        if (panel) panel.focus({ preventScroll: true });

        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => this.dialog.classList.add('is-visible'));
        });
      }

      close() {
        if (!this.dialog.open) return;
        if (!this.designMode) this.remember();

        this.dialog.classList.remove('is-visible');
        const finish = () => {
          this.dialog.close();
          document.documentElement.classList.remove('email-popup-open');
          document.removeEventListener('keydown', this.onKeydown);
          if (this.lastFocus && typeof this.lastFocus.focus === 'function') {
            this.lastFocus.focus({ preventScroll: true });
          }
        };
        if (reducedMotion()) finish();
        else window.setTimeout(finish, 250);
      }

      remember() {
        store.set('localStorage', this.key + ':closed', String(Date.now()));
        store.set('sessionStorage', this.key + ':closed', '1');
      }

      onSubmit() {
        // Native submit is required: Shopify's bot protection (hCaptcha) hooks the
        // submit event to attach its token. The page reloads and we reopen in the
        // success state via handleReturnFromNativeSubmit().
        store.set('sessionStorage', this.key + ':pending', '1');
        this.clearError();
        this.setLoading(true);
        window.setTimeout(() => this.setLoading(false), 8000);
      }

      cleanUrl() {
        try {
          const url = new URL(window.location.href);
          url.searchParams.delete('customer_posted');
          window.history.replaceState(window.history.state, '', url.pathname + url.search);
        } catch (e) {}
      }

      handleReturnFromNativeSubmit() {
        if (!store.get('sessionStorage', this.key + ':pending')) return false;
        store.remove('sessionStorage', this.key + ':pending');

        const stateEl = this.querySelector('[data-form-state]');
        const state = stateEl ? stateEl.dataset.formState : '';
        const posted = state === 'success' || window.location.search.indexOf('customer_posted=true') !== -1;

        if (posted) {
          this.cleanUrl();
          this.open();
          this.showSuccess();
          return true;
        }
        if (state === 'error') {
          this.open();
          const input = this.querySelector('input[type="email"]');
          if (input) input.setAttribute('aria-invalid', 'true');
          return true;
        }
        return false;
      }

      showSuccess() {
        this.setLoading(false);
        store.set('localStorage', this.key + ':subscribed', '1');
        this.dataset.state = 'success';

        const heading = this.querySelector('[data-popup-success-heading]');
        if (heading) heading.focus();
        if (this.statusEl) this.statusEl.textContent = heading ? heading.textContent.trim() : '';

        this.dispatchEvent(new CustomEvent('email-popup:subscribed', { bubbles: true }));
        try {
          if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
            Shopify.analytics.publish('email_popup_signup', { code: this.dataset.code || '' });
          }
        } catch (e) {}
      }

      showError(message) {
        if (!this.errorEl) return;
        this.errorEl.textContent = message || this.errorEl.dataset.fallback || '';
        this.errorEl.hidden = false;
        const input = this.querySelector('input[type="email"]');
        if (input) {
          input.setAttribute('aria-invalid', 'true');
          input.focus();
        }
      }

      clearError() {
        if (!this.errorEl) return;
        this.errorEl.hidden = true;
        this.errorEl.textContent = '';
        const input = this.querySelector('input[type="email"]');
        if (input) input.removeAttribute('aria-invalid');
      }

      setLoading(loading) {
        if (!this.submitBtn) return;
        this.submitBtn.setAttribute('aria-busy', loading ? 'true' : 'false');
      }

      async copyCode(btn) {
        const code = this.dataset.code || '';
        let copied = false;
        try {
          await navigator.clipboard.writeText(code);
          copied = true;
        } catch (e) {
          const codeEl = this.querySelector('[data-popup-code]');
          if (codeEl) {
            const range = document.createRange();
            range.selectNodeContents(codeEl);
            const selection = window.getSelection();
            selection.removeAllRanges();
            selection.addRange(range);
            try { copied = document.execCommand('copy'); } catch (err) {}
          }
        }
        if (!copied) return;
        btn.textContent = btn.dataset.copied || 'Copied';
        if (this.statusEl) this.statusEl.textContent = btn.dataset.copied || 'Copied';
        window.setTimeout(() => {
          btn.textContent = btn.dataset.label || 'Copy code';
        }, 2000);
      }
    }

    customElements.define('email-popup', EmailPopup);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
